
var Const = {};

Const.USER_TYPE =	{
					    HOST : 1,
					    PARTICIPANT : 2
					}

Const.STREAM_TYPE = {
					    LOW : 1,
					    HIGH : 0
					}

Const.HOST_RESOLUTION_TYPE = {
	LD : "180p",
	SD : "360p",
	HD : "720p",
	HDP : "1080p",
	HDP2 : "1440p",
	HDPP : "4kp",
}
Const.HOST_RESOLUTION = [];
Const.HOST_RESOLUTION[Const.HOST_RESOLUTION_TYPE.HDPP] = "4K_1";
Const.HOST_RESOLUTION[Const.HOST_RESOLUTION_TYPE.HDP2] = "1440p";
Const.HOST_RESOLUTION[Const.HOST_RESOLUTION_TYPE.HDP] = "1080p_3";
Const.HOST_RESOLUTION[Const.HOST_RESOLUTION_TYPE.HD] = "720p_1";
Const.HOST_RESOLUTION[Const.HOST_RESOLUTION_TYPE.SD] = "360p_11";
Const.HOST_RESOLUTION[Const.HOST_RESOLUTION_TYPE.LD] = "180p_1";

Const.PARTICIPANT_RESOLUTION_TYPE = {
	LD : "90p",
	SD : "180p",
	HD : "360p"
}
Const.PARTICIPANT_RESOLUTION = [];
Const.PARTICIPANT_RESOLUTION[Const.PARTICIPANT_RESOLUTION_TYPE.HD] = "360p_11";
Const.PARTICIPANT_RESOLUTION[Const.PARTICIPANT_RESOLUTION_TYPE.SD] = "180p_1";
Const.PARTICIPANT_RESOLUTION[Const.PARTICIPANT_RESOLUTION_TYPE.LD] = "90p_1";

Const.BASE_API_PATH = process.env.REACT_APP_API_URL;
Const.STREAM_INJECT_UID = 666;

Const.RAISE_HAND_CLICKED_ON_BOX = "RAISE_HAND_CLICKED_ON_BOX";
Const.AUDIO_CLICKED_ON_BOX = "AUDIO_CLICKED_ON_BOX";
Const.STREAM_CLICKED_ON_BOX = "STREAM_CLICKED_ON_BOX";
Const.STREAM_EJECT_ON_BOX = "STREAM_EJECT_ON_BOX";
Const.STREAM_MUE_MIC = "STREAM_MUE_MIC";
Const.STREAM_UNMUE_MIC = "STREAM_UNMUE_MIC";

Const.APPEREANCE = {"like":"like_emoji.svg","dislike":"dislike_emoji.svg","easy":"easy_emoji.svg","too-hard":"ouch_emoji.svg", "perfect":"beast_emoji.svg", "awesome":"cool_emoji.svg", 
					 "joined":"join.png", "left":"left.png",
					1: "darkpurple.png",
					2: "burgundy.png",
					3: "red.png",
					4: "graphite.png",
					5: "asianspice.png",
					6: "blackberry.png",
					7: "leather.png",
					8: "grass.png",
					9: "whitechocolate.png",
					11: "like.png",
					12: "dislike.png",
					13: "easy.png",
					14: "too-hard.png",
					15: "perfect.png",
					16: "awesome.png",
					17: "lightpurple.png",
					18: "blueberry.png",
					19: "cedar.png",
					20: "toast.png",
					21: "vanilla.png",
					22: "mushrooms.png",
					23: "darkchocolate.png",
					24: "licorice.png",
					25: "darkfruit.png",
					26: "asianspice.png",
					27: "blackberry.png",
					28: "blueberry.png",
					29: "cedar.png",
					30: "toast.png",
					31: "vanilla.png",
					32: "mushrooms.png",					
					33: "darkbrown.png",
					34: "darkgold.png",
					35: "darkpink.png",
					36: "darkyellow.png",
					37: "lightamber.png",
					38: "lightbrown.png",
					39: "lightgold.png",
					40: "lightpink.png",
					41: "lightyellow.png",
					42: "mediumamber.png",
					43: "mediumbrown.png",
					44: "mediumgold.png",
					45: "mediumpink.png",
					46: "mediumpurple.png",
					47: "mediumyellow.png",
					48: "darkamber.png",
					49: "apple.png",
					50: "almond.png",
					51: "apricot.png",
					52: "banana.png",
					53: "blackcherry.png",
					54: "blackcurrant.png",
					55: "butter.png",
					56: "clove.png",
					57: "coffee.png",
					58: "honey.png",
					59: "lemon.png",
					60: "melon.png",
					61: "mint.png",
					62: "orange.png",
					63: "pear.png",
					64: "pineapple.png",
					65: "plum.png",
					66: "raspberry.png",
					67: "redcurrants.png",
					68: "smoky.png",
					69: "strawberry.png",
					70: "acacia.png",
					71: "anise.png",
					72: "asianfivespice.png",
					73: "bakingspices.png",
					74: "beeswax.png",
					75: "bellpepper.png",
					76: "blackpepper.png",
					77: "boysenberry.png",
					78: "bubblegum.png",
					79: "cinnamon.png",
					80: "claypot.png",
					81: "cocoa.png",
					82: "cranberry.png",
					83: "cream.png",
					84: "date.png",
					85: "driedfruit.png",
					86: "elderflower.png",
					87: "eucalyptus.png",
					88: "fennel.png",
					89: "fig.png",
					90: "fruitcake.png",
					91: "ginger.png",
					92: "grapefruit.png",
					93: "greenalmond.png",
					94: "gooseberry.png",
					95: "guava.png",
					96: "hibiscus.png",
					97: "iris.png",
					98: "jalapeno.png",
					99: "marmalade.png",
					100: "kiwi.png",
					101: "lager.png",
					102: "lavender.png",
					103: "lime.png",
					104: "lilac.png",
					105: "lychee.png",
					106: "honeysuckle.png",
					107: "mango.png",
					108: "nectarine.png",
					109: "nuts.png",
					110: "olive.png",
					111: "peach.png",
					112: "peony.png",
					113: "persimmon.png",
					114: "petroleum.png",
					115: "pomegranate.png",
					116: "potpourri.png",
					117: "pottingsoil.png",
					118: "quince.png",
					119: "raisins.png",
					120: "redbeet.png",
					121: "redpepper.png",
					122: "redplum.png",
					123: "rose.png",
					124: "saffron.png",
					125: "slate.png",
					126: "sourcherry.png",
					127: "sourdough.png",
					128: "strawberry.png",
					129: "sundriedtomato.png",
					130: "thyme.png",
					131: "tobacco.png",
					132: "tomato.png",
					133: "tomatoleaf.png",
					134: "truffle.png",
					135: "violet.png",
					136: "volcanicrocks.png",
					137: "wetgravel.png",
					138: "whitepepper.png"
				}

Const.EVENT = {
				MESSAGE		: "message",
				STATUS		: "status",
				INTERACTION : "interaction",
				DEVICE		: "device"
			}

Const.SCRIPT_STATE = {
				0	: "Initial",
				1	: "Playing",
				2	: "Pause",
				3 	: "End"
			}

Const.MESSAGE = {
				SEND	: "send",
				RECEIVE	: "receive"
			}

window.Const = Const;
export default Const;